import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useState } from 'react';
import * as Yup from 'yup';
import { Form, Formik } from 'formik';
import HTTPMethod from 'http-method-enum';
import { Modal } from '@yoweb/ui/components/Modal';
import { Box } from '@yoweb/ui/components/Box';
import { Title } from '@yoweb/ui/components/typography/Title';
import { Text } from '@yoweb/ui/components/typography/Text';
import { Input } from '@yoweb/ui/components/form';
import { Button } from '@yoweb/ui/components/buttons';
import { fetchJson } from '@yoweb/utils/fetchJson';
import { API_EMPLOYERS_WHITE_PAPER_SUBMISSION, API_EMPLOYERS_WHITE_PAPER_DOWNLOAD } from '@store/constants/routes';
import { useTranslation } from '@yoweb/next-i18next';
import { useYoForm } from '@yoweb/ui/hooks/forms';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var WhitePaperModal = function WhitePaperModal(_ref) {
  var isOpen = _ref.isOpen,
      onClose = _ref.onClose;

  var _useTranslation = useTranslation(['common', 'employers-form']),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  var _useState = useState(false),
      showDownload = _useState[0],
      setShowDownload = _useState[1];

  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(values) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetchJson(API_EMPLOYERS_WHITE_PAPER_SUBMISSION, {
                method: HTTPMethod.POST,
                body: JSON.stringify(_objectSpread(_objectSpread({}, values), {}, {
                  locale: i18n.language
                }))
              });

            case 2:
              setShowDownload(true);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var _useYoForm = useYoForm('common', function () {
    return {
      employerEmail: {
        defaultValue: '',
        validation: Yup.string().trim().email(t('common:validation.enter-valid-address')).required(t('common:validation.required'))
      }
    };
  }),
      initialState = _useYoForm.initialState,
      schema = _useYoForm.schema;

  return /*#__PURE__*/_jsx(Modal, {
    fullScreenMobile: true,
    hasCloseButton: true,
    isOpen: isOpen,
    onClose: onClose,
    children: /*#__PURE__*/_jsxs(Box, {
      mb: "normal4",
      mt: "normal2",
      px: {
        _: 'normal2',
        md: 'normal4'
      },
      children: [/*#__PURE__*/_jsx(Box, {
        mb: "normal1",
        children: /*#__PURE__*/_jsx(Title, {
          textAlign: "center",
          children: showDownload ? t('employers-form:white-paper.success.title') : t('employers-form:white-paper.title')
        })
      }), /*#__PURE__*/_jsx(Text, {
        textAlign: "center",
        children: showDownload ? t('employers-form:white-paper.success.body') : t('employers-form:white-paper.body')
      }), !showDownload && /*#__PURE__*/_jsx(Formik, {
        enableReinitialize: true,
        initialValues: initialState,
        validationSchema: schema,
        onSubmit: handleSubmit,
        validateOnMount: true,
        children: function children(_ref3) {
          var isSubmitting = _ref3.isSubmitting,
              dirty = _ref3.dirty,
              isValid = _ref3.isValid,
              submitCount = _ref3.submitCount;
          return /*#__PURE__*/_jsxs(Form, {
            children: [/*#__PURE__*/_jsx(Box, {
              mt: "normal2",
              children: /*#__PURE__*/_jsx(Input, {
                "data-testid": "email-input",
                id: "employerEmail",
                label: "",
                name: "employerEmail"
              })
            }), /*#__PURE__*/_jsx(Box, {
              mt: "normal3",
              mb: "normal1",
              children: /*#__PURE__*/_jsx(Button, {
                "data-testid": "white-paper-submit",
                size: "lg",
                type: "submit",
                isFullWidth: true,
                isLoading: isSubmitting,
                isDisabled: !dirty || isSubmitting || submitCount > 0 && !isValid,
                children: t('employers-form:white-paper.button.continue')
              })
            }), /*#__PURE__*/_jsx(Button, {
              "data-testid": "cancel-form",
              size: "lg",
              type: "button",
              variant: "secondary",
              onClick: onClose,
              isFullWidth: true,
              children: t('employers-form:white-paper.button.cancel')
            })]
          });
        }
      }), showDownload && /*#__PURE__*/_jsx(Box, {
        mt: 'normal3',
        children: /*#__PURE__*/_jsx(Button, {
          "data-testid": "download-submit",
          as: "a",
          variant: "primary",
          href: "".concat(API_EMPLOYERS_WHITE_PAPER_DOWNLOAD, "?locale=").concat(i18n.language),
          children: t('employers-form:white-paper.button.download')
        })
      })]
    })
  });
};